import { translate } from '#packages/i18n';
import type { WidgetComponent } from '@wix/chat-widget-common-widgets';
import React from 'react';
import { SingleSelectWidget } from '../singleSelectWidget/singleSelectWidget';
import { KEYS } from './constants';

type Key = keyof typeof KEYS;
export interface SuggestionsChatWidgetProps {
  suggestions: { name: Key; message: Key }[];
}

export const SuggestionsChatWidget: WidgetComponent<
  SuggestionsChatWidgetProps
> = ({ data: { suggestions }, context }) => {
  return (
    <SingleSelectWidget
      data={{
        text: 'Here is the list of features you can choose from:',
        options: suggestions.map((item) => ({
          title: translate(KEYS[item.name].title),
          button: {
            label: translate('theme_assistant_widget_select_button'),
            respondText: translate(KEYS[item.name].respondText),
          },
          text: translate(KEYS[item.name].text),
          value: translate(KEYS[item.name].text),
        })),
        showMore: {
          maxToShowByDefault: 1,
          exceptions: [2],
        },
      }}
      context={context}
    />
  );
};

export const SUGGESTIONS_WIDGET = 'SUGGESTIONS_WIDGET';

/*
MESSAGE:
<<{"widget": "SUGGESTIONS_WIDGET", "data": {"suggestions": [
      { "name": "mydomain1.com", "message": "mydomain1.com" },
          { "name": "mydomain2.com", "message": "mydomain2.com" },
          { "name": "mydomain3.com", "message": "mydomain3.com" }
        ]}}>>
*/
